<template>
  <transition
    enter-active-class="transition duration-300 ease-out transform"
    enter-class="scale-95 opacity-0"
    enter-to-class="scale-100 opacity-100"
    leave-active-class="transition duration-150 ease-in transform"
    leave-class="scale-100 opacity-100"
    leave-to-class="scale-95 opacity-0"
  >
    <div
      v-if="openModal"
      class="
        flex
        items-center
        justify-center
        fixed
        left-0
        bottom-0
        w-full
        h-full
        z-40
      "
      style="background-color: #00000099"
    >
      <div class="bg-white rounded-lg w-1/2 max-h-95/100">
        <div class="flex flex-col items-start p-4">
          <div class="flex items-center w-full">
            <div class="text-gray-900 font-bold text-lg">Add Member</div>
            <svg
              class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 18"
              @click="closeModal"
            >
              <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
              />
            </svg>
          </div>
          <hr class="w-full my-3" />
          <div class="form-control w-full">
            <div class="mr-auto mt-3">
              <button
                :class="
                  Type === 'username' ? 'btn btn-primary' : 'btn btn-outline'
                "
                @click="Type = 'username'"
              >
                From username
              </button>
              <button
                :class="
                  Type === 'Engagement'
                    ? 'btn btn-primary ml-3'
                    : 'btn btn-outline ml-3'
                "
                @click="Type = 'Engagement'"
              >
                From Engagement
              </button>
            </div>

            <input
              type="text"
              :placeholder="
                Type === 'username' ? 'Twitter Username' : 'Tweet Url'
              "
              class="input mt-3 input-bordered w-full mb-2"
              required
              name="enrollusername"
              :input="(enrollusername = enrollusername.trim())"
              v-model="enrollusername"
            />

            <div class="form-control mt-2" v-if="Type === 'Engagement'">
              <label
                class="cursor-pointer label justify-start"
                style="width: fit-content"
              >
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="Comments"
                />
                <span class="label-text text-lg ml-3"> Replies / Comments</span>
              </label>
              <label
                class="cursor-pointer label justify-start"
                style="width: fit-content"
              >
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="Likes"
                />
                <span class="label-text text-lg ml-3"> Likes</span>
              </label>
              <label
                class="cursor-pointer label justify-start"
                style="width: fit-content"
              >
                <input
                  type="checkbox"
                  checked="sendnotification"
                  class="checkbox checkbox-primary"
                  v-model="Retweets"
                />
                <span class="label-text text-lg ml-3">Retweets</span>
              </label>
            </div>
            <textarea
              v-if="enroll"
              class="textarea h-32 mt-2 textarea-bordered w-full mb-1"
              placeholder="Message"
              required
              name="content"
              v-model="content"
            />
          </div>
          <label
            v-if="thisCourseType !== courseType.SEGMENT"
            class="cursor-pointer label mt-2 justify-start"
            style="width: fit-content"
          >
            <input
              type="checkbox"
              checked="sendnotification"
              class="checkbox checkbox-primary"
              v-model="enroll"
            />
            <span class="label-text text-lg ml-3">Invite to join</span>
          </label>
          <label
            v-if="!enroll && thisCourseType !== courseType.SEGMENT"
            class="cursor-pointer label justify-start"
            style="width: fit-content"
          >
            <input
              type="checkbox"
              checked="sendnotification"
              class="checkbox checkbox-primary"
              v-model="sendnotification"
            />
            <span class="label-text text-lg ml-3"
              >Notify user of being added to segment</span
            >
          </label>
          <hr class="w-full my-3" />
          <div class="ml-auto">
            <button
              :disabled="
               Type === 'Engagement'
                  ? enrollusername.indexOf('https://twitter.com/') === -1 ||
                    (enroll && content.trim() === '') ||
                    (!Retweets && !Likes && !Comments)
                  : (enroll && content.trim() === '') ||
                    enrollusername.trim() === ''
              "
              :class="['', isButtonDisable ? 'tooltip tooltip-top text-gray-500 bg-gray-400 outline-none border-none cursor-default' : ' ']"
              data-tip="Maximum member limit reached"
              class="btn btn-primary"
              @click="()=>isButtonDisable ? '': inviteUser()"
            >
              Add
            </button>
            <button class="btn btn-outline ml-3" @click="closeModal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import utils from '@/services/utils';
import courseType from '../../utils/Constants/courseType.constants';

export default {
  name: 'InviteMemberModal',
  props: {
    courseId: String,
    courseName: { type: String, default: '' },
    openModal: Boolean,
    closeModal: Function,
    thisCourseType: { type: String, default: courseType.SEGMENT },
    isPipelineUser: { type: Boolean, default: false },
    isButtonDisable: { type: Boolean, default: false },
  },
  data() {
    return {
      content: `I think you will like my new series: ${this.courseName}`,
      Type: 'username',
      Comments: false,
      Likes: false,
      Retweets: false,
      enrollusername: '',
      enroll: false,
      sendnotification: false,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.userDetails;
      },
      set(newData) {
        return newData;
      },
    },
    inviteMemberModal() {
      return this.$store.state.courses.inviteMemberModal;
    },
    courseType() {
      return courseType;
    },
    addButtonDisable() {
      return this.isButtonDisable;
    },
  },
  async mounted() {
    if (!this.userInfo) {
      await this.$store.dispatch('getMyDetails', {});
    }
    this.user = this.$store.state.userDetails;
  },
  methods: {
    async inviteUser() {
      try {
        let currentUserId = this.user?.userId;
        if (this.$route.query.userId) {
          currentUserId = this.$route.query.userId;
        }
        if (this.isPipelineUser) {
          if (
            1 + this.$store.state.pipeline.pipelineStudentsCount >
            this.user?.myAccess?.pipelineMemberLimit
          ) {
            utils.setStatusMsg(this, 'Maximum pipeline member exceed');
            return this.invitecancel();
          }
        }
        this.$store.commit('toggleLoading', true);
        const res = await this.$store.dispatch('inviteMemberToCourse', {
          username: this.enrollusername,
          courseId: this.courseId,
          creatorId: currentUserId,
          message: this.content,
          Type: this.Type,
          enroll: !this.enroll,
          sendnotification: this.sendnotification,
          Comments: this.Comments,
          Retweets: this.Retweets,
          Likes: this.Likes,
          isPipelineUser: this.isPipelineUser,
        });

        this.$store.commit('toggleLoading', false);
        this.invitecancel();
        utils.setStatusMsg(this, res?.message);
      } catch (error) {
        console.log({ error });
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, error?.message || 'something went wrong');
        this.invitecancel();
      }
      this.$store.commit('SET_TEMP_NOTIFICATION', 'Updating segment');
      return null;
    },
    invitecancel() {
      this.closeModal();
      this.enrollusername = '';
      this.content = `I think you will like my new series: ${this.courseName}`;
      this.Type = 'username';
      this.Comments = false;
      this.Retweets = false;
      this.Likes = false;
      setTimeout(() => {
        this.$store.commit('SET_TEMP_NOTIFICATION', '');
      }, 30000);
    },
  },
};
</script>

<style></style>
